import CancelIcon from './parts/CancelIcon'
import SuccessIcon from './parts/SuccessIcon'
import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { hexToRgba } from '@/utils/hexToRgba'
import { FC } from 'react'
import { StyleSheet } from 'react-native'
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated'

type OverlayType = 'success' | 'cancel'

type Props = {
    type: OverlayType
    message: string
}

const overlayConfig: Record<
    OverlayType,
    { background: string; Icon: FC<{ height?: number; width?: number }> }
> = {
    success: {
        background: hexToRgba(ColorEnum.EMERALD_700, 0.5),
        Icon: SuccessIcon,
    },
    cancel: {
        background: hexToRgba(ColorEnum.BRICK_700, 0.5),
        Icon: CancelIcon,
    },
}

const Overlay: FC<Props> = ({ type, message }) => {
    const { background, Icon } = overlayConfig[type]

    return (
        <Animated.View
            entering={FadeIn}
            exiting={FadeOut}
            style={[styles.container, { backgroundColor: background }]}
        >
            <Icon />
            <Typography.Heading variant="h2" style={{ color: ColorEnum.WHITE }}>
                {message}
            </Typography.Heading>
        </Animated.View>
    )
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        zIndex: 1000,
        ...StyleSheet.absoluteFillObject,
    },
})

export default Overlay
